import React from 'react';
import 'components/styles/update-password.css';
import CustomInput from './custom-input';
import { useUpdatePassword } from 'hooks/useUpdatePassword';
import Header from './login-header';
import Footer from './footer';
import { ReactComponent as CloseEye } from 'assets/images/passwordClosedEyeIcon.svg';
import { ReactComponent as OpenEye } from 'assets/images/passwordOpenEyeIcon.svg';
import { ReactComponent as HintIcon } from 'assets/images/hint-icon.svg';
import { ReactComponent as TickMark } from 'assets/images/tick-mark.svg';

const UpdatePassword = () => {
  const {
    oldPassword,
    newPassword,
    confirmPassword,
    setOldPassword,
    setNewPassword,
    setConfirmPassword,
    showOldPassword,
    setShowOldPassword,
    showNewPassword,
    setShowNewPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    oldPasswordError,
    newPasswordError,
    confirmPasswordError,
    handleUpdate,
    passwordChangeSuccessful,
    updateStatus,
    passwordsError
  } = useUpdatePassword();

  return (
    <>
      <Header />
      <div className="update-password-container">
        <div className="update-password-box">
          <div className="update-password-head">Change your password</div>
          <div className="update-password-inputs">
            <div className="passwordInputField">
              <CustomInput
                type={showOldPassword ? 'text' : 'password'}
                label="Enter old password"
                value={oldPassword}
                onChange={setOldPassword}
                success={passwordChangeSuccessful}
                error={oldPasswordError}
              />
              <button onClick={() => setShowOldPassword(!showOldPassword)} className="eyeToggler">
                {showOldPassword ? (
                  <OpenEye/>
                ) : (
                  <CloseEye/>
                )}
              </button>
            </div>

            <div className="passwordInputField">
              <CustomInput
                type={showNewPassword ? 'text' : 'password'}
                label="Enter new password"
                value={newPassword}
                onChange={setNewPassword}
                success={passwordChangeSuccessful}
                error={newPasswordError}
              />
              <button onClick={() => setShowNewPassword(!showNewPassword)} className="eyeToggler">
                {showNewPassword ? (
                  <OpenEye/>
                ) : (
                  <CloseEye/>
                )}
              </button>
            </div>

            <div className="passwordInputField">
              <CustomInput
                type={showConfirmPassword ? 'text' : 'password'}
                label="Confirm new password"
                value={confirmPassword}
                error={confirmPasswordError}
                onChange={setConfirmPassword}
                success={passwordChangeSuccessful}
              />
              <button
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="eyeToggler">
                {showConfirmPassword ? (
                  <OpenEye/>
                ) : (
                  <CloseEye/>
                )}
              </button>
              {passwordsError  && (
                <div className="error-message">
                  <HintIcon/>
                  {passwordsError}
                </div>
              )}
            </div>
          </div>
          <div className="update" onClick={handleUpdate}>
            {updateStatus}
          </div>
        </div>
        {passwordChangeSuccessful && (
          <div className="password-success-message">
            <TickMark/>
            <div className="success-message">Password update successfully, logging you in...</div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default UpdatePassword;
